module.exports = __webpack_public_path__ + "static/media/0022_IMG_LES_ENSEIGNES_EN_CUISINE.8f74ac9e.webp";